import styled from 'styled-components'
import Col from 'reactstrap/lib/Col'
import { SIZES } from '../../../constants'

export default styled(Col)`
  flex: 1 1 auto;
  padding: 0;
  -ms-flex-negative: 0;
  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    margin: 0 0 15px 0;
  }

  @media (min-width: ${SIZES.BREAKPOINT_XS}px) {
    max-width: 30%;
    margin: 0 5px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
`
